var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share",
    transform: "translate(-4877 1311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3040",
    "data-name": "Rectangle 3040",
    width: 24,
    height: 24,
    transform: "translate(4877 -1311)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-share-2523032",
    d: "M87.427,7.133a3.556,3.556,0,0,1-2.845-1.427L76.7,10.426a2.74,2.74,0,0,1,.027.278c0,.114-.027.222-.036.334l7.849,4.728a3.555,3.555,0,1,1-.678,2.071c0-.133.027-.26.036-.389L76.027,12.8h0a3.568,3.568,0,1,1-.053-4.261l7.921-4.629c-.009-.113-.036-.224-.036-.341a3.568,3.568,0,1,1,3.568,3.568Zm0,12.488h0a1.784,1.784,0,1,0-1.262-.522,1.783,1.783,0,0,0,1.262.522ZM73.156,8.917h0a1.784,1.784,0,1,0,1.262.522,1.784,1.784,0,0,0-1.262-.522ZM87.427,1.781a1.784,1.784,0,1,0,1.261.522A1.784,1.784,0,0,0,87.427,1.781Z",
    transform: "translate(4808.429 -1309.997)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/shareLink.504da8dd6474779aba7ac1affd56dcfa.svg";
export { ForwardRef as ReactComponent };